import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { installStaleAssetRecovery } from '../../components/recoverStaleAssets'
import { ToastProvider } from '@/components/ui'
import { queryClient } from './lib/query-client'
import { initLogRocket } from './lib/logrocket'
import App from './App'
import './index.css'

installStaleAssetRecovery()
initLogRocket()

/**
 * Application Root
 *
 * Providers:
 * - QueryClientProvider: TanStack Query for data fetching
 * - BrowserRouter: React Router for navigation
 */
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)


